export function dateOptions(__, T) {
  const all = {
    label: __(T.misc.all),
    value: 'all'
  }
  const today = {
    label: __(T.misc.today),
    value: 'today'
  }
  const lastWeek = {
    label: __(T.misc.lastweek),
    value: 'lastweek'
  }
  const specific = {
    label: __(T.misc.specific),
    value: 'specific'
  }
  return { all, today, lastWeek, specific }
}

export function statusOptions(__, T) {
  const all = {
    label: 'ALL',
    value: 'all'
  }
  const inbound = {
    label: 'INBOUND',
    value: 'IN_INBOUND'
  }
  const draft = {
    label: 'DRAFT',
    value: 'DRAFT'
  }
  const received = {
    label: 'RECEIVED',
    value: 'RECEIVED'
  }
  const forceReceived = {
    label: 'FORCE RECEIVED',
    value: 'FORCE_RECEIVED'
  }
  const outbound = {
    label: 'OUTBOUND',
    value: 'IN_OUTBOUND'
  }
  const outboundError = {
    label: 'OUTBOUND ERROR',
    value: 'OUTBOUND_ERROR'
  }
  const inboundError = {
    label: 'INBOUND ERROR',
    value: 'INBOUND_ERROR'
  }
  const inTransit = {
    label: 'IN TRANSIT',
    value: 'IN_TRANSIT'
  }
  return { all, inbound, draft, received, forceReceived, outbound, outboundError, inboundError, inTransit }
}

export function getDateModalOptions(__, T) {
  const opts = dateOptions(__, T)
  return [opts.all, opts.today, opts.lastWeek, opts.specific]
}

export function getStatusModalOptions(__, T, operationConfig) {
  const opts = statusOptions(__, T)
  if (operationConfig.type === 'INBOUND') {
    return [opts.all, opts.inbound, opts.inTransit, opts.draft, opts.received, opts.forceReceived, opts.inboundError]
  } else if (operationConfig.type === 'OUTBOUND') {
    return [opts.all, opts.outbound, opts.draft, opts.received, opts.forceReceived, opts.outboundError]
  }
  return [
    opts.all,
    opts.inbound,
    opts.inTransit,
    opts.outbound,
    opts.draft,
    opts.received,
    opts.inboundError,
    opts.outboundError
  ]
}

export function getModalOptionsByTab(tabId, { __, T, operationConfig }) {
  if (tabId === 'date') {
    return getDateModalOptions(__, T)
  }
  if (tabId === 'status') {
    return getStatusModalOptions(__, T, operationConfig)
  }
  return []
}

export function getResetFilterByTab(tabId, filterParams) {
  if (tabId === 'date') {
    return {
      ...filterParams,
      creationDateStart: undefined,
      creationDateEnd: undefined
    }
  }
  if (tabId === 'status') {
    return {
      ...filterParams,
      statuses: undefined
    }
  }
  return filterParams
}

export interface Filter<TFilters = any, TTranslations = any> {
  key: string
  type: 'select' | 'date'
  label: (__, T: TTranslations) => string
  getOptions: (
    filters: TFilters,
    __: any,
    T: TTranslations
  ) => {
    label: string
    value: string
  }[]
  multiple?: boolean
}

export const filtersConfig: Filter[] = [
  {
    key: 'statuses',
    type: 'select',
    label: (__, T) => __(T.fields.status),
    getOptions: (__, T, operationConfig) =>
      Object.values(
        getModalOptionsByTab('status', {
          __,
          T,
          operationConfig: operationConfig
        })
      ).map((opt) => ({
        label: opt.label,
        value: opt.value
      })),
    multiple: true
  },
  {
    key: 'creationDate',
    type: 'date',
    label: (__, T) => __(T.fields.creation_date),
    getOptions: (__, T, operationConfig) => getModalOptionsByTab('date', { __, T, operationConfig: operationConfig }),
    multiple: false
  }
]
